import useCurrentLocation from "@thooks/useCurrentLocation"
import { useNewEditTemplateCollectionServices } from "./useNewEditTemplateCollectionServices"
import { useEffect } from "react"
import { useNewEditTemplateCollectionContext } from "../context/NewEditTemplateCollectionContext"
import useRedirectTo from "@thooks/useRedirectTo"
import { useNewEditCollectionSave } from "./useNewEditCollectionSave"

export const useNewEditTemplateCollection = () => {

    const { setLoadingTemplate, setChargeDetail, setChargeDebtorsData } = useNewEditTemplateCollectionContext()
    const {
        handleSaveTemplate,
        getInitialData,
        loadingTemplate
    } = useNewEditCollectionSave()
    const { param } = useCurrentLocation()
    const { handleRedirectTo } = useRedirectTo()
    const { createDefaultChargeService } = useNewEditTemplateCollectionServices()

    useEffect(() => {
        //Solamente se crea un nuevo cobro si la ruta es /new, en caso de otro id no se crea
        //y se obtienen los detalles del cobro actual
        (async () => {
            if (param.templateId.includes('new')) {
                const res = await createDefaultChargeService({ setLoading: setLoadingTemplate })
                //Redirigit al cobro creado y limpiar para evitar regresar a crear una plantilla accidentalmente                
                return handleRedirectTo(`/administration-collection/template/${res.id}`, undefined, {
                    replace: true
                })
            }
            getInitialData()
        })()
    }, [
        param.templateId,
        handleRedirectTo,
        getInitialData,
        createDefaultChargeService,
        setLoadingTemplate,
        setChargeDebtorsData,
        setChargeDetail,
    ])

    return {
        handleSaveTemplate,
        loadingTemplate
    }
}